import {Link} from "react-router";
import {error404, gridShape} from '@img/index.js'

export default function NotFound() {
    return (
        <div className="relative flex flex-col items-center justify-center min-h-screen p-6 overflow-hidden">
            {/* Grid shapes */}
            <div className="absolute right-0 top-0 -z-1 w-full max-w-[250px]">
                <img src={gridShape} alt="grid" className="w-full"/>
            </div>
            <div className="absolute left-0 bottom-0 -z-1 w-full max-w-[250px] rotate-180">
                <img src={gridShape} alt="grid" className="w-full"/>
            </div>

            <div className="mx-auto w-full max-w-[472px] text-center">
                <h1 className="text-[34px] font-bold text-(--text-primary) mb-5!">ERROR</h1>

                <img src={error404} alt="404" className="max-w-full"/>

                <p className="mb-0 mt-10 text-lg text-(--text-secondary)">
                    We can't seem to find the page you are looking for!
                </p>

                <Link to="/" className="inline-flex items-center justify-center mt-6 px-5 py-3.5 text-sm font-medium text-(--text-primary) bg-white border border-(--border-color) rounded-(--radius-md) shadow-[0_1px_2px_rgba(0,0,0,0.05)] no-underline transition-colors hover:bg-(--bg-grey)">
                    Back to Home Page
                </Link>
            </div>

            <p className="mb-0 absolute bottom-6 left-1/2 -translate-x-1/2 text-sm text-(--text-secondary) text-center">
                &copy; {new Date().getFullYear()} - Hopn
            </p>
        </div>
    );
}
